import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, GraduationCap, ArrowRight, User } from 'lucide-react';
import InstructorReviewBadge from '../reviews/InstructorReviewBadge';

export default function InstructorCard({ instructor }) {
  // Safe default for photo
  const photo = instructor.photoURL;

  return (
    <div className="bg-white dark:bg-zinc-900 rounded-3xl border border-slate-200 dark:border-white/10 overflow-hidden shadow-sm hover:shadow-[0_10px_40px_rgba(245,158,11,0.15)] transition-all duration-500 group flex flex-col h-full rtl">
      {/* Top Banner (Header Background) */}
      <div className="h-24 bg-gradient-to-r from-amber-500 to-amber-600 dark:from-amber-600 dark:to-amber-700 relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10"></div>
      </div>
      
      {/* Content */}
      <div className="px-6 pb-6 pt-0 relative flex-1 flex flex-col items-center text-center">
        {/* Avatar positioned over the banner */}
        <div className="w-24 h-24 rounded-2xl bg-white dark:bg-zinc-800 border-4 border-white dark:border-zinc-900 shadow-xl overflow-hidden -mt-12 mb-4 relative flex items-center justify-center">
          {photo ? (
            <img src={photo} alt={instructor.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
          ) : (
            <User className="w-10 h-10 text-slate-300 dark:text-zinc-600" />
          )}
          {/* Approved Badge */}
          <div className="absolute -bottom-1 -left-1 bg-white dark:bg-zinc-900 rounded-full p-0.5">
            <ShieldCheck className="w-5 h-5 text-emerald-500" />
          </div>
        </div>

        {/* Name and Specialization */}
        <h3 className="text-xl font-black text-slate-900 dark:text-white mb-2 line-clamp-1">{instructor.name}</h3>
        <div className="flex items-center justify-center gap-1.5 text-slate-500 dark:text-zinc-400 font-bold text-sm mb-3 bg-slate-50 dark:bg-white/5 py-1.5 px-3 rounded-xl border border-slate-100 dark:border-white/5">
          <GraduationCap className="w-4 h-4 text-indigo-500" />
          <span className="line-clamp-1">{instructor.instructorData?.specialization || 'طاقم التدريس'}</span>
        </div>

        <div className="mb-4 flex items-center justify-center bg-amber-50/50 dark:bg-amber-500/5 px-3 py-1 rounded-full border border-amber-100/50 dark:border-amber-500/10">
          <InstructorReviewBadge instructorId={instructor.id} />
        </div>

        {/* Bio specific */}
        <p className="text-slate-500 dark:text-zinc-400 font-medium text-sm leading-relaxed line-clamp-3 mb-6 flex-1">
          {instructor.instructorData?.bio || 'لا توجد نبذة حالياً...'}
        </p>

        {/* Action Button */}
        <Link 
          to={`/instructor/${instructor.id}`}
          className="w-full py-3 px-4 rounded-xl font-bold border-2 border-slate-100 dark:border-white/5 text-slate-700 dark:text-white hover:bg-amber-500 hover:border-amber-500 hover:text-white dark:hover:bg-amber-600 dark:hover:border-amber-600 transition-all flex items-center justify-center gap-2 group/btn"
        >
          <span>عرض الملف الشخصي</span>
          <ArrowRight className="w-4 h-4 group-hover/btn:-translate-x-1 transition-transform" />
        </Link>
      </div>
    </div>
  );
}
